import isEmpty from 'lodash/isEmpty';

import { Pipe, PipeTransform } from '@angular/core';

/*
 * Replace characters in string
 *
 * Usage for replace all:
 *   value | replaceALL : 'Search string' : 'Replace string'
 * Example:
 *   {{ 'It sounds odd at first_ but the result will be hilarious' | replaceAll : '_' : ',' }} =>
 * formats to: It sounds odd at first, but the result will be hilarious
*/

@Pipe({ name: 'replaceAll' })
export class ReplaceALLPipe implements PipeTransform {
  public transform(value: string, searchValue: string, replaceValue: string): string {

    if (isEmpty(value) || typeof searchValue !== 'string' || typeof replaceValue !== 'string') {
      return value;
    }

    return value.replace(new RegExp(searchValue, 'g'), replaceValue);
  }
}
